import { SelectedContext } from '@/context/SelectedContext';
import { useContext } from 'react';

export const useSelected = () => useContext(SelectedContext);
